/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { importTeamSearchResultSchema } from './importTeamSearchResultSchema';

export const pageResponseImportTeamSearchResultSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(importTeamSearchResultSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
